import React, { useMemo } from "react";

import { FormattedDate } from "react-intl";

import Icon from "../../icons/Icon";
import StyledDivs from "../StyledDivs";

const ConstrationSite = ({ notes }) => {
    const constructionSite = useMemo(() => {
        const now = new Date();

        return notes
            .filter(
                (item) =>
                    item.baustelle_start &&
                    item.baustelle_ende &&
                    item.text_aktiv
            )
            .map(({ baustelle_start, baustelle_ende, text_value }) => ({
                start: new Date(baustelle_start),
                end: new Date(baustelle_ende),
                text: text_value ?? null,
            }))
            .find(
                ({ start, end }) =>
                    !isNaN(start.getTime()) &&
                    !isNaN(end.getTime()) &&
                    end >= now
            );
    }, [notes]);

    if (!constructionSite) {
        return null;
    }

    return (
        <StyledDivs.SubItemsWithIcon>
            <Icon iconName="contruction" />
            <StyledDivs.SubItems>
                <StyledDivs.SubItemHeadline>
                    Baustelle:
                </StyledDivs.SubItemHeadline>
                <div>
                    <FormattedDate
                        value={constructionSite.start}
                        format="short"
                    />{" "}
                    -{" "}
                    <FormattedDate
                        value={constructionSite.end}
                        format="short"
                    />
                </div>
                {constructionSite.text && <div>{constructionSite.text}</div>}
            </StyledDivs.SubItems>
        </StyledDivs.SubItemsWithIcon>
    );
};

export default ConstrationSite;
